import React from 'react';

import styles from './ContentHeader.scss';
import GradeRangeSquare from 'Components/GradeRangeSquare';

const ContentHeader = ({
  title,
  tagline,
  gradeRange,
  sponsored,
  hideSquare,
  sponsoredBy,
}) => {
  return (
    <div
      className={`ContentHeader ${
        hideSquare ? 'ContentHeader--no-square' : ''
      }`}
    >
      {!hideSquare ? (
        <GradeRangeSquare gradeRange={gradeRange} size="large" />
      ) : null}
      <div className="ContentHeader__text">
        {sponsored ? (
          <div className="ContentHeader__sponsored">Sponsored</div>
        ) : null}
        <h1 className="ContentHeader__headline">{title}</h1>
        <p className="ContentHeader__description">{tagline}</p>
      </div>
      {sponsoredBy}
    </div>
  );
};

export default ContentHeader;
